export const HISTORIC_PRESETS = [
  {
    name: "Historisk Verdensatlas 1890-stil (Global)",
    url: "https://server.arcgisonline.com/ArcGIS/rest/services/NatGeo_World_Map/MapServer/tile/{z}/{y}/{x}",
    filter: "sepia(0.55) contrast(1.08) brightness(0.95)",
    attribution: "National Geographic, Esri",
  },
  {
    name: "Arkiv-flyfoto 1930-stil Sorthvitt/Sepia (Global)",
    url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
    filter: "grayscale(0.88) sepia(0.35) contrast(1.18) brightness(0.92)",
    attribution: "Esri",
  },
  {
    name: "Historisk Terreng & Relieffkart (Global)",
    url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Physical_Map/MapServer/tile/{z}/{y}/{x}",
    filter: "sepia(0.45) contrast(1.1)",
    attribution: "Esri",
  },
  {
    name: "Moderne Satellitt / Flyfoto (Esri – Global)",
    url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
    filter: "none",
    attribution: "Esri",
  },
  {
    name: "Kartverket Topografisk (Kun Norge)",
    url: "https://cache.kartverket.no/v1/wmts/1.0.0/topo/default/webmercator/{z}/{y}/{x}.png",
    filter: "sepia(0.35) contrast(1.05)",
    attribution: "Kartverket",
  },
  {
    name: "Kartverket Sjøkart / Kystkart (Kun Norge)",
    url: "https://cache.kartverket.no/v1/wmts/1.0.0/sjokartraster/default/webmercator/{z}/{y}/{x}.png",
    filter: "sepia(0.25)",
    attribution: "Kartverket",
  },
];
